import { h, Component, Fragment } from 'preact';
import WidgetComponent from 'components/WidgetComponent'
import {connect} from 'react-redux'
import style from './style'
import dayjs from 'lib/helpers/dayjs';

import VisitActions from 'actions/VisitActions';
import {
    Row,
    Col,
    Form,
    Button,
    SquareImage,
    I18n,
    Container,
    Toggle,
    CreditCardIcon,
    CreditCardNumber
} from 'components/elements'
import {
    AppointmentActions,
    AccountActions,
    AvailabilityActions,
    PageActions,
    PaymentActions,
    SelectedTimeSlotActions,
    SelectedPatientActions,
    TrackingActions
} from 'actions'
import {
    ContactInformation,
    PatientInformation,
    GenericPatientInformation
} from 'components/partials'
import store from 'reducers'
import { uuid } from 'lib/helpers';
import CreditCardExpiry from 'components/elements/CreditCardExpiry';
import {FASpinner, FAUpload} from 'components/elements/FontAwesome'
import _ from 'lodash'
import editIcon from "../../../assets/icons/svg/edit.svg";
import providerImage from "../../../assets/icons/svg/provider_image.svg" //assets/icons/svg/provider_image.svg";

// Animation Component
import LottieAnimation from 'components/elements/LottieAnimation';
import animationLoad from "../../../assets/animations/load.json";

// Icons
import leftChevron from "../../../assets/icons/svg/chevron_left.svg";
import rightChevron from "../../../assets/icons/svg/chevron_right.svg";

@connect((state)=> state)
export default class Confirmation extends WidgetComponent {
	constructor(){
        super()
        this.state = {
            editing: {},
            termsToggled: false,
            smsToggled: false,
            accessToggled: false,
            toggleError: false,
            error: ''
        }
        this.handleSubmit = this.handleSubmit.bind(this)
        this.getPatientBreed = this.getPatientBreed.bind(this)
        this.submitAppointments = this.submitAppointments.bind(this)
        this.handleTogglePatientEdit = this.handleTogglePatientEdit.bind(this)
        this.handleToggleAccountEdit = this.handleToggleAccountEdit.bind(this)
        this.handleToggleTerms = this.handleToggleTerms.bind(this)
        this.handleToggleSMS = this.handleToggleSMS.bind(this)
        this.grantAccess = this.grantAccess.bind(this)
        this.handleEditAppointment = this.handleEditAppointment.bind(this)
        this.bookAppointments = this.bookAppointments.bind(this)
        this.handleEditCard = this.handleEditCard.bind(this)
        this.handleBackButton = this.handleBackButton.bind(this);
    }
    
    componentWillMount(){
        let editing = {}
        editing[this.account.id] = false
        this.patients.forEach((patient)=>{
            editing[patient.id] = false
        })
        this.setState({
            editing,
            error: ''
		})
    }

    get hasRestrictions(){
        const appointmentType =  this.props.appointmentTypes[this.props.filters.appointmentTypeID]
        return (appointmentType.rules || []).length > 0
    }

    get administrator() {
        return this.props.administrators[this.props.selectedTimeSlot.administratorID] || {}
    }

    get timeSlot() {
        return {
            ...this.props.selectedTimeSlot,
            startsAt: dayjs(this.props.selectedTimeSlot.startsAt).format("hh:mm A"),
            endsAt: dayjs(this.props.selectedTimeSlot.endsAt).format("hh:mm A"),
            date: dayjs(this.props.selectedTimeSlot.startsAt).format("MM/DD/YYYY")
        }
    }
    get customTOSLink() {
        return this.props.organization.customTOS
    }

    get session(){
        return this.props.session || {}
    }

    get account() {
        return this.session.account || {};
    }

    get patients() {
        let patients = []
        Object.keys(this.props.patients || {}).forEach((key)=>{
            if(Object.keys(this.props.selectedPatients).includes(key)){
                let _patient = this.props.patients[key]
                let patient = {
                    ..._patient,
                    name: _patient.firstName,
                    age: _patient.age,
                    reason: _patient.reason,
                    gender: (this.props.genders[_patient.genderID] || {}).name,
                    species: (this.props.classifications[this.getPatientBreed(_patient).classificationID] || {}).name,
                    breed: (this.props.breeds[_patient.breedID] || {}).name
                }
                if(!patient.age && patient.birthday){
                    patient.age = dayjs().diff(patient.birthday,"years")
                }
                patients.push(patient)
            }
        })
        return patients
    }
    
    getPatientBreed(patient) {
        return this.props.breeds[patient.breedID] || {}
    }

    submitAppointments(){
        this.setState({
            error: '',
            isVerifyingData: true
        })
        this.componentWillSubmit().then((response)=>{
            let checkData = {
                organizationID: this.props.organization.id,
                accountID: this.account.id,
                administratorID: this.props.selectedTimeSlot.administratorID,
                appointmentTypeID: this.props.filters.appointmentTypeID,
                startsAt: dayjs(this.props.selectedTimeSlot.startsAt).format(),
                endsAt: dayjs(this.props.selectedTimeSlot.endsAt).format(),
                appointmentCount: this.patients.length,
            }
    
            if(!this.props.selectedTimeSlot.endsAt){
                checkData.endsAt = dayjs(checkData.startsAt).add(1,"minute").format()
            }
         
            if(!this.props.config.placeholderAppointment){
                AppointmentActions.checkAvailability(checkData).then((response)=>{
                    this.setState({
                        isVerifyingData: false
                    })
                    const valid = [
                        'allUserChargeCard',
                        'newUserChargeCard'
                    ];
                    if(valid.includes(this.props.config.type) && this.props.config.cost){
                        if(response.data.available){
                            return PaymentActions.create({
                                amount: this.props.invoiceItems.reduce((acc, item)=>(
                                    acc + item.cost
                                ), 0),
                                card: this.props.selectedCard
                            }).then(()=>{
                                
                                return response
                            })
                        }
                    }else{
                        return response
                    }
                }).then(
                    this.bookAppointments
                )
                
            }else{
                this.bookAppointments({
                    data:{
                        available: true
                    }
                })
            }
        })
    }

    bookAppointments(response){
        this.setState({
            appointmentError: ''
        })
        let data
        let promises = [];
        if(!response.data.available){
            this.setState({
                error: "Sorry, but this appointment has been reserved. Please select another time."
            })
            this.componentFailedToSubmit()
        } else {
            VisitActions.create({
                organizationID: this.props.organization.id,
                accountID: this.account.id,
                administratorID: this.props.selectedTimeSlot.administratorID,
                startsAt: dayjs(this.props.selectedTimeSlot.startsAt).format(),
                endsAt: dayjs(this.props.selectedTimeSlot.endsAt).format()
            }).then(({data: visitData})=>{
                let visitID = visitData.id
                let patientError = false
                let showReason = !(this.props.config.reason || {}).hide
                if(_.isNil(showReason)) showReason = true
            
                this.patients.forEach((_patient)=>{
                    if(showReason && !_patient.reason && this.props.selectedTimeSlot.id){
                        patientError = true
                    } else {
                        if(this.props.config.skip.includes("appointment.reason")){
                            _patient.reason = _.get(this, `props.appointmentTypes[${this.props.filters.appointmentTypeID}]`).name || "default"
                        }
                        data = {
                            organizationID: this.props.organization.id,
                            reason: _patient.reason,
                            accountID: this.account.id,
                            patientID: _patient.id,
                            visitID,
                            administratorID: this.props.selectedTimeSlot.administratorID,
                            appointmentTypeID: this.props.filters.appointmentTypeID,
                            startsAt: dayjs(this.props.selectedTimeSlot.startsAt).format(),
                            endsAt: dayjs(this.props.selectedTimeSlot.endsAt).format(),
                        }
                        if(!this.props.selectedTimeSlot.endsAt){
                            data.endsAt = dayjs(data.startsAt).add(1,"minute").format()
                        }
                        promises.push(AppointmentActions.create(data))
                    }
                })
                
                if(patientError){
                    this.setState({
                        appointmentError: "Please enter your reason for visit."
                    })
                    this.componentFailedToSubmit()
                } else {
    
                    Promise.all(promises).then((response)=>{
                        let allAppointmentsSet = true
                        let errors = []
                        for(let res of response){
                            if(res.data.error){
                                allAppointmentsSet = false
                                errors.push(res.data.error)
                            }
                        }
                        if(allAppointmentsSet){
                            super.componentDidSubmit()

                            TrackingActions.reset()
                        } else {
                            this.setState({
                                appointmentError: errors.join(', ')
                            })
                            this.componentFailedToSubmit()
                        }
                    }).catch((e)=>{
                        this.setState({
                            appointmentError: e
                        })
                        this.componentFailedToSubmit()
                    })
                }
            })
        }
    }

    grantAccess (e) {
        AccountActions.grant({organizationID: this.props.organization.id})
	};

    handleEditAppointment(){
        AvailabilityActions.clear()
        SelectedTimeSlotActions.set({});
        PageActions.navToTimeSlots();
    }

    handleBackButton(){
        if(this.hasRestrictions){
            AvailabilityActions.clear()
            SelectedTimeSlotActions.set({});
        }else {
            SelectedPatientActions.clear()
        }
        PageActions.navToTimeSlots();
    }

    handleEditCard(e){
        e.preventDefault()
        PageActions.navToPayment()
    }

    handleTogglePatientEdit(patient){
        let editing = this.state.editing
        editing[patient.id] = !editing[patient.id]
        this.setState({
			editing
		})
    }

    handleToggleAccountEdit(){
        let editing = this.state.editing
        editing[this.account.id] = !editing[this.account.id]
        this.setState({
			editing
		})
    }

    handleToggleTerms(){
        this.setState({
            termsToggled: !this.state.termsToggled,
            toggleError: false
        })
    }
    
    get isVerifyingData(){
        return this.state.isVerifyingData
    }

    get isIntegrated() {
        return _.get(this, "props.currentOrganization.integrations",[]).find((integration) => (
            integration.pim && integration.active
        ))
    }

    get isTimeSlotValid(){
        return !this.props.selectedTimeSlot.invalid
    }

    handleToggleSMS(){
        this.setState({
            smsToggled: !this.state.smsToggled,
            toggleError: false
        })
    }
// mark ***
    handleSubmit(e){
        e.preventDefault()
        if((this.account.mobilePhone && !this.state.smsToggled) || !this.state.termsToggled){
            this.setState({
                toggleError: true
            })
            return
        } 
        this.submitAppointments()
    }



	render() {
		return (
			<div className={style.confirmation}>
                {
                    this.componentIsLoading() && (
                        <div className={style.loadingConfirmation }>
                            <div className={style.animation}>
                                <LottieAnimation animationData={animationLoad} />
                            </div>
                            <div class={style.title}>
                                <I18n>gettingYourAppointmentScheduled</I18n>
                            </div>
                            <div class={style.subtitle}>
                                <span><I18n>pleaseDoNotClickAwayFromThisPage</I18n></span>
                            </div>
                        </div>
                    )
                }
                {this.componentIsLoading() && this.isIntegrated ? (
                    this.isVerifyingData ? (
                        <div style={{fontSize: "30px", textAlign: "center", padding: "50px 0"}}>
                            <I18n>verifyingData</I18n>
                            &nbsp;
                            &nbsp;
                            <FASpinner />
                        </div>
                        
                    ) : (
                        <div style={{fontSize: "30px", textAlign: "center", padding: "50px 0"}}>
                            <I18n>processingData</I18n>
                            &nbsp;
                            &nbsp;
                            <FASpinner />
                        </div>
                    )
                ) : (
                    <Fragment>
                        <Row>
                            <Col span={{sm:24}}>
                                <h1><I18n>almostThere</I18n></h1>
                                <h2 style={{marginBottom:"16px"}}><I18n>reviewAndSubmit</I18n></h2>
                                <Row>

                                    {!this.isTimeSlotValid && (
                                        <Col span={{sm:24}} class={[style.confirmCol, style.selectNewButton]}>
                                            <Container
                                                class={style.invalidTimeSlotContainer}
                                            >
                                                <Button 
                                                    onClick={this.handleEditAppointment}
                                                    class={style.invalidTimeSlotButton}
                                                >
                                                    <I18n>selectNewTimeSlot</I18n>
                                                </Button> 
                                                <div className={style.errorMessage}>
                                                    <p>
                                                       <I18n>errorInvalidTimeSlot</I18n>
                                                    </p>
                                                    <p>
                                                        <I18n>clickNewTimeSlot</I18n>
                                                    </p>    
                                                </div>
                                            </Container>
                                        </Col>
                                    )}
                                    {(!this.props.config.placeholderAppointment && this.isTimeSlotValid) && 
                                        <Col span={{sm:24}} class={style.confirmCol}>
                                            <Container title='Resource' class={style.appointmentInformationContainer}>
                                                <div className={style.appointmentContainerHeader}>
                                                    <div className={style.textHeader}>
                                                        <label>
                                                            <I18n>appointmentInformation</I18n>
                                                        </label>
                                                    </div>
                                                    <div class={style.editText}>
                                                        <Button id="contact-edit" type='button' theme={"gray"} onClick={this.handleEditAppointment}>
                                                            <img src={editIcon} alt="Edit Icon"/>
                                                            <span><I18n>edit</I18n></span>
                                                        </Button>
                                                    </div>
                                                </div>
                                                <div className={style.appointmentContainerBody}>
                                                    <Row class={`${style.infoRow} ${style.gridToImage}`}>
                                                        {this.administrator.image ? (
                                                            <SquareImage
                                                                image={this.administrator.image}
                                                                minWidth="64px"
                                                                maxWidth="64px"
                                                            />
                                                        )
                                                        :
                                                            <div className={style.defaultImage}>
                                                                <img src={providerImage} alt="default Image"/>
                                                            </div>
                                                        }
                                                        <Col class={style.infoCol}>
                                                            <label class={`${style.colTitle}`}>
                                                                {I18n.t("doctorName").toUpperCase()}
                                                            </label>
                                                            <label>
                                                                { `${this.administrator.firstName} ${this.administrator.lastName}`}
                                                            </label>
                                                        </Col>
                                                    </Row>
                                                    <Row class={`${style.infoRow}`}>
                                                        <Col class={style.infoCol}>
                                                            <label class={`${style.colTitle}`}>
                                                                {I18n.t("date").toUpperCase()}
                                                            </label>
                                                            <label>
                                                                {this.timeSlot.date}
                                                            </label>
                                                        </Col>
                                                    </Row>
                                                    <Row class={`${style.infoRow} ${style.grid}`}>
                                                        <Col class={style.infoCol}>
                                                            <label class={`${style.colTitle}`}>
                                                                {I18n.t("startTime").toUpperCase()}
                                                            </label>
                                                            <label>
                                                                {this.timeSlot.startsAt}
                                                            </label>
                                                        </Col>
                                                        <Col class={style.infoCol}>
                                                            <label class={`${style.colTitle}`}>
                                                                {I18n.t("endTime").toUpperCase()}
                                                            </label>
                                                            <label>
                                                                {this.timeSlot.endsAt}
                                                            </label>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Container>
                                        </Col>
                                    }
                                    <Col span={{sm:24}} class={style.confirmCol}>
                                        <ContactInformation  
                                            containerKey="confirmation-contact"
                                            editing={!!this.state.editing[this.account.id]} />
                                    </Col>
                                </Row>
                                <Row>    
                                    <Col span={{sm:24}} class={`${style.confirmCol} ${style.removeTopPadding}`}>
                                        <Container title='Patients'>
                                            {this.patients.map((patient,i)=>(
                                                <Fragment>
                                                    {this.props.config.genericPatients ? (
                                                        <GenericPatientInformation 
                                                            key={patient.id} 
                                                            editing={!!this.state.editing[patient.id]}
                                                            patient={patient} 
                                                            half={true} />
                                                    ) : (
                                                        <PatientInformation 
                                                            key={patient.id} 
                                                            editing={!!this.state.editing[patient.id]}
                                                            patient={patient} 
                                                            half={true}
                                                            type='transparent'
                                                        />
                                                    )}
                                                </Fragment>
                                            ))}
                                        </Container>
                                    </Col>
                                    {this.props.selectedCard.id && (
                                        <Col span={{sm:24}} class={style.confirmCol}>
                                            <Container title={'Payment Information'}>
                                                {this.props.invoiceItems.map((item)=>(
                                                    <div>{item.title} {item.cost}</div>
                                                ))}
                                                <br />
                                                <strontg>Total:&nbsp; </strontg>
                                                {this.props.invoiceItems.reduce((acc, item)=>(
                                                    acc + item.cost
                                                ), 0)}
                                                <hr class={style.line} />
                                                <div class={style.editText} onClick={this.handleEditCard}>Edit</div>
                                                <br />
                                                {this.props.selectedCard.name}
                                                <br />
                                                <CreditCardIcon type={this.props.selectedCard.cardType} />
                                                &nbsp;
                                                &nbsp;
                                                <CreditCardNumber cardNumber={this.props.selectedCard.cardNumber} />
                                                <CreditCardExpiry
                                                    expMonth={this.props.selectedCard.expMonth}
                                                    expYear={this.props.selectedCard.expYear}
                                                />
                                                
                                            </Container>
                                        </Col>
                                    )}
                                </Row>
                            </Col>
                        </Row>
                        <Container type='transparent' class={style.termsAndPoliciesContainer}>
                            <div className={style.toggles}>
                                {this.account.mobilePhone &&
                                    <Toggle class={style.confirmToggle} selected={this.state.smsToggled} onSelect={this.handleToggleSMS}>
                                        <I18n>iAgreeToReceiveTextMessageAlerts</I18n>
                                    </Toggle>
                                }
                                <Toggle class={style.confirmToggle} selected={this.state.termsToggled} onSelect={this.handleToggleTerms}>
                                    <I18n>iAgreeToTheTermsOfService</I18n>
                                </Toggle>
                            </div>
                            <div className={style.termsAndPolicy}>
                                <a href="https://www.nextinline.io/terms-of-use/" target="_blank" rel="noopener noreferrer">{I18n.t("termsOfUse")}</a>
                                <a href="https://www.nextinline.io/privacy-policy/" target="_blank" rel="noopener noreferrer">{I18n.t("privacyPolicy")}</a>
                            </div>
                            {this.customTOSLink && (
                                <Fragment>
                                    <a href={this.customTOSLink} target="_blank" rel="noopener noreferrer"><I18n>TOSFor</I18n> {this.props.organization.name}</a>
                                    <br></br>
                                    <br></br>
                                </Fragment>
                            )}
                            {this.state.toggleError &&
                                <div class={style.errorMessage}><I18n>pleaseAcceptTermsAbove</I18n></div>
                            }
                            {this.state.appointmentError && 
                                <div class={style.errorMessage}><I18n>sorryThereWasErrorReservingYourAppointment</I18n>: {this.state.appointmentError}</div>
                            }
                            {!this.isTimeSlotValid && (
                                <div class={style.errorMessage}>
                                    <p><I18n>errorInvalidTimeSlot</I18n></p>
                                    <p><I18n>scrollUpToSelectNewTimeSlot</I18n></p>
                                </div>
                            )}
                            {
                                this.isTimeSlotValid && (
                                    <div className={style.containerButtons}>
                                        {
                                            !this.props.config.hideBackButton && (
                                                <Button type="button" theme="gray" spinner={this.componentIsLoading()} onClick={this.handleBackButton}>
                                                    <img src={leftChevron} alt="Left Chevron"/>
                                                    <I18n>back</I18n>
                                                </Button>
                                            )
                                        }
                                        {this.state.error ?
                                            <div class={style.errorMessage}>{this.state.error}</div>
                                        :
                                            <Button spinner={this.componentIsLoading()} onClick={this.handleSubmit}>
                                                <I18n>submit</I18n>
                                                <img src={rightChevron} alt="Right Chevron"/>
                                            </Button> 
                                        }
                                    </div>
                                )
                            }
                        </Container>
                    </Fragment>
                )}
            </div>
		)
	}
}


// WEBPACK FOOTER //
// ./components/templates/Confirmation/index.js